import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import supabase from '../../supabase/supabase';

const { FiCheck } = FiIcons;

const plans = [
  {
    id: 'single',
    name: 'Single',
    price: '$10',
    codes: '1 Dynamic QR Code',
    popular: false
  },
  {
    id: 'five',
    name: 'Five Pack',
    price: '$40',
    codes: '5 Dynamic QR Codes',
    popular: true
  },
  {
    id: 'ten',
    name: 'Ten Pack',
    price: '$70',
    codes: '10 Dynamic QR Codes',
    popular: false
  }
];

const Pricing = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    };
    checkUser();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user || null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleAction = () => {
    if (!user) {
      // Unauthenticated: Redirect to login
      navigate('/login');
    } else {
      // Authenticated: Redirect to dashboard upgrade section
      navigate('/dashboard');
    }
  };

  return (
    <section id="pricing" className="w-full py-24 px-6 bg-white border-b-4 border-black">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-4">
            Simple Pricing
          </h2>
          <p className="text-xl font-bold">Pay once. Use forever. No subscriptions.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {plans.map((plan) => (
            <div 
              key={plan.id}
              className={`relative bg-white border-4 border-black p-8 flex flex-col ${plan.popular ? 'brutal-shadow-lg transform md:-translate-y-4' : 'brutal-shadow'}`}
            >
              {plan.popular && (
                <div className="absolute top-0 right-0 transform translate-x-2 -translate-y-4 bg-black text-white px-4 py-1 font-black text-sm border-2 border-black">
                  MOST POPULAR
                </div>
              )}
              
              <h3 className="text-2xl font-black uppercase mb-2">{plan.name}</h3>
              <div className="text-5xl font-black mb-8 pb-8 border-b-4 border-black">
                {plan.price}
              </div>

              <ul className="flex-grow space-y-4 mb-8 font-bold">
                <li className="flex items-center gap-3">
                  <div className="p-1 bg-black text-white shrink-0">
                    <SafeIcon icon={FiCheck} className="w-4 h-4" />
                  </div>
                  {plan.codes}
                </li>
                <li className="flex items-center gap-3">
                  <div className="p-1 bg-black text-white shrink-0">
                    <SafeIcon icon={FiCheck} className="w-4 h-4" />
                  </div>
                  Unlimited Scans
                </li>
                <li className="flex items-center gap-3">
                  <div className="p-1 bg-black text-white shrink-0">
                    <SafeIcon icon={FiCheck} className="w-4 h-4" />
                  </div>
                  Unlimited Updates
                </li>
                <li className="flex items-center gap-3">
                  <div className="p-1 bg-black text-white shrink-0">
                    <SafeIcon icon={FiCheck} className="w-4 h-4" />
                  </div>
                  High-Res Downloads
                </li>
              </ul>

              <button 
                onClick={handleAction}
                className={`w-full py-4 font-black text-lg border-2 border-black brutal-shadow-sm brutal-hover transition-all flex items-center justify-center gap-2 ${
                  plan.popular ? 'bg-black text-white' : 'bg-white text-black'
                }`}
              >
                {user ? 'Buy Now' : 'Sign in to Buy'}
              </button>
            </div>
          ))}
        </div>
        
        <p className="mt-12 text-center font-bold text-gray-500 uppercase text-sm tracking-widest">
          Secure checkout via Stripe. {user ? 'Purchase more slots in your dashboard.' : 'Account required for fulfillment.'}
        </p>
      </div>
    </section>
  );
};

export default Pricing;